import {useState, useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'

export const useHandleSearch = searchType => {
	const dispatch = useDispatch()

	const [searchValue, setSearchValue] = useState('')
	const searchQuery = useSelector(state => state.components.searchQueries[searchType] || '')

	const handleChange = e => {
		const value = e.target.value
		setSearchValue(value)
		if (!value) {
			dispatch({type: 'SEARCH_QUERIES', searchType: searchType, searchQuery: ''})
		}
	}

	const handleKeyDown = e => {
		if (e.key === 'Enter') {
			dispatch({type: 'SEARCH_QUERIES', searchType: searchType, searchQuery: e.target.value})
		}
	}

	const handleClear = () => {
		setSearchValue('')
		dispatch({type: 'SEARCH_QUERIES', searchType: searchType, searchQuery: ''})
	}

	useEffect(() => {
		setSearchValue(searchQuery)
	}, [searchQuery])

	return {handleChange, handleKeyDown, handleClear, searchValue, searchQuery}
}
